import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { GifColors } from "../../../../theme";
import { useEffect, useState } from "react";
import StyledTableCell from "../Tables/StyledTableCell";
import { finalRecommendations } from "../../Constants";
import RefereeSummaryModal from "../RefereeSummaryModal";

const CalculateAvgScore = (referees) => {
  if (!referees) return 0;
  const scores = referees.map((r) => r.evaluationTotal);
  const sum = scores.reduce((a, b) => a + b, 0);
  const avg = sum / scores.length || 0;
  const round = Math.floor(avg * 100) / 100;
  return round;
};

const getRecommendText = (recommend) => {
  const recommendation = finalRecommendations.filter(
    (r) => r.value === recommend
  );
  if (!recommendation || recommendation.length === 0) return "";
  else return recommendation[0].label;
};

const RefereeRow = (props) => {
  const { proposalReferee } = props;
  const [summaryOpen, setSummaryOpen] = useState(false);
  return (
    <>
      <Tooltip title="Click to Show Full Details" arrow>
        <TableRow
          key={proposalReferee.itemID}
          onClick={() => setSummaryOpen(true)}
          style={{ cursor: "pointer" }}
        >
          <StyledTableCell>{proposalReferee.name}</StyledTableCell>
          <StyledTableCell>
            {getRecommendText(proposalReferee.refereeFinalRecommend)}
          </StyledTableCell>
          <StyledTableCell>{proposalReferee.evaluationTotal}</StyledTableCell>
        </TableRow>
      </Tooltip>
      <RefereeSummaryModal
        open={summaryOpen}
        onClose={() => setSummaryOpen(false)}
        proposalRefereeId={proposalReferee.itemID}
      />
    </>
  );
};

export default function ProposalTable(props) {
  const { proposalRefrees } = props;
  const [avgScore, setAvgScore] = useState();
  useEffect(() => {
    const avgScore = CalculateAvgScore(proposalRefrees);
    setAvgScore(avgScore);
  }, [proposalRefrees]);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography whiteSpace={"nowrap"} textOverflow={'ellipsis'}>Reviewers</Typography>
            </TableCell>
            <TableCell>
              <Typography whiteSpace={"nowrap"} textOverflow={'ellipsis'}>Reviewer Grading</Typography>
            </TableCell>
            <TableCell>
              <Typography whiteSpace={"nowrap"} textOverflow={'ellipsis'}>Reviewer Score</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {proposalRefrees.map((referee) => (
            <RefereeRow key={referee.itemID} proposalReferee={referee} />
          ))}
          <TableRow>
            <TableCell style={{ borderBottomWidth: 0 }}></TableCell>
            <TableCell style={{ borderBottomWidth: 0 }}></TableCell>
            <TableCell
              style={{
                borderBottomWidth: 0,
              }}
            >
              <Typography fontWeight={600} color={GifColors.generalBlack}>
                {`Score Avg.  ${avgScore}`}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={3} style={{ borderBottomWidth: 0 }}>
              <Typography
                fontWeight={700}
                align="center"
                display={"block"}
              >
                ** Click on the "Reviewers status" button to see who recommended
                a particular reviewer**
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
